var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCarrierFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2673_1431)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D64550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2485 37H14.4985C15.1885 37 15.7485 37.56 15.7485 38.25C15.7485 38.94 15.1885 39.5 14.4985 39.5H13.2485C12.5585 39.5 11.9985 38.94 11.9985 38.25C11.9985 37.56 12.5585 37 13.2485 37Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2485 32H14.4985C15.1885 32 15.7485 32.56 15.7485 33.25C15.7485 33.94 15.1885 34.5 14.4985 34.5H13.2485C12.5585 34.5 11.9985 33.94 11.9985 33.25C11.9985 32.56 12.5585 32 13.2485 32Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9985 49.1996H9.99854V16.6248C9.99854 15.6864 10.1596 14.7549 10.4748 13.871L10.5699 13.6044C11.1582 11.9546 12.4504 10.6523 14.0957 10.0512C14.9135 9.75246 15.7773 9.59961 16.648 9.59961H34.1648C34.4978 9.59961 34.8302 9.62792 35.1584 9.68423C36.3556 9.88968 37.4598 10.4612 38.3188 11.3202L38.4985 11.5C39.396 12.4935 39.9239 13.7659 39.9932 15.103L39.9985 15.2067V49.1996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7485 17H18.9985C19.6885 17 20.2485 17.56 20.2485 18.25C20.2485 18.94 19.6885 19.5 18.9985 19.5H17.7485C17.0585 19.5 16.4985 18.94 16.4985 18.25C16.4985 17.56 17.0585 17 17.7485 17Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 17H25.2485C25.9385 17 26.4985 17.56 26.4985 18.25C26.4985 18.94 25.9385 19.5 25.2485 19.5H23.9985C23.3085 19.5 22.7485 18.94 22.7485 18.25C22.7485 17.56 23.3085 17 23.9985 17Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7485 22H18.9985C19.6885 22 20.2485 22.56 20.2485 23.25C20.2485 23.94 19.6885 24.5 18.9985 24.5H17.7485C17.0585 24.5 16.4985 23.94 16.4985 23.25C16.4985 22.56 17.0585 22 17.7485 22Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 22H25.2485C25.9385 22 26.4985 22.56 26.4985 23.25C26.4985 23.94 25.9385 24.5 25.2485 24.5H23.9985C23.3085 24.5 22.7485 23.94 22.7485 23.25C22.7485 22.56 23.3085 22 23.9985 22Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2485 22H31.4985C32.1885 22 32.7485 22.56 32.7485 23.25C32.7485 23.94 32.1885 24.5 31.4985 24.5H30.2485C29.5585 24.5 28.9985 23.94 28.9985 23.25C28.9985 22.56 29.5585 22 30.2485 22Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2485 17H31.4985C32.1885 17 32.7485 17.56 32.7485 18.25C32.7485 18.94 32.1885 19.5 31.4985 19.5H30.2485C29.5585 19.5 28.9985 18.94 28.9985 18.25C28.9985 17.56 29.5585 17 30.2485 17Z",
    fill: "#FFEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2193 38.6854C18.6177 40.9777 20.4032 42.4714 23.7008 44.8714C27.1011 43.8527 28.6834 42.7756 30.7545 39.6866C31.1713 36.3335 30.7537 31.3836 30.7537 31.3836C30.7537 31.3836 27.6852 29.4902 24.968 29.0054C22.1856 29.2943 20.7974 29.7143 18.1679 31.0171C18.0205 34.4054 17.8146 36.1802 18.2193 38.6854Z",
    fill: "#D64550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4277 29.5945L24.7344 28.0382C24.5807 27.9872 24.4157 27.9872 24.2619 28.0382L19.5679 29.5945C18.0312 30.1045 16.9985 31.5348 16.9985 33.154V37.0323C16.9985 41.9537 22.252 44.9643 23.8629 45.7698C23.8629 45.7698 24.2522 46 24.5004 46C24.7486 46 25.0936 45.82 25.0936 45.82C26.7135 45.1682 31.9985 42.6093 31.9985 37.0323V33.154C31.9985 31.5348 30.9651 30.1045 29.4277 29.5945ZM30.4979 37.0323C30.4979 41.6687 25.9321 43.8655 24.5334 44.428C23.1175 43.72 18.4985 41.0942 18.4985 37.0323V33.154C18.4985 32.1828 19.1179 31.3248 20.0404 31.018L24.4982 29.5397L28.9559 31.018C29.8776 31.324 30.4979 32.1828 30.4979 33.154V37.0323Z",
    fill: "#D64550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.559 36.6201L27.2787 34.9003C27.5719 34.6071 27.5719 34.1331 27.2787 33.8398C26.9854 33.5466 26.5115 33.5466 26.2182 33.8398L24.4986 35.5596L22.7789 33.8398C22.4857 33.5466 22.0117 33.5466 21.7185 33.8398C21.4252 34.1331 21.4252 34.6071 21.7185 34.9003L23.4381 36.6201L21.7185 38.3398C21.4252 38.6331 21.4252 39.1071 21.7185 39.4003C21.8647 39.5466 22.0567 39.6201 22.2487 39.6201C22.4407 39.6201 22.6327 39.5466 22.7789 39.4003L24.4986 37.6806L26.2182 39.4003C26.3645 39.5466 26.5565 39.6201 26.7485 39.6201C26.9405 39.6201 27.1324 39.5466 27.2787 39.4003C27.5719 39.1071 27.5719 38.6331 27.2787 38.3398L25.559 36.6201Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2673_1431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCarrierFound);
export default __webpack_public_path__ + "static/media/no-carrier-found.79b12f45396995341ac46f39e5a9acbe.svg";
export { ForwardRef as ReactComponent };